import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "help_options",
        object: "help_option",
        header: [
            { text: "Titulo", value: "title" },
            { text: "Descripcion", value: "description" },
            { text: "Requiere Foto", value: "requires_photo" },
            { text: "Requiere Descripcion", value: "requires_description" },
            { text: "Acciones", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
